const initialState = {
  loading: null,
  data: null,
  error: [null, null],
  current: null,
};

export default initialState;
